import React from 'react'

const DownArrowSmallIcon = props => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M11.9465 5.45334H7.79316H4.05317C3.41317 5.45334 3.09317 6.22667 3.5465 6.68001L6.99983 10.1333C7.55317 10.6867 8.45317 10.6867 9.0065 10.1333L10.3198 8.82L12.4598 6.68001C12.9065 6.22667 12.5865 5.45334 11.9465 5.45334Z'
      fill='#1F1F1F'
    />
  </svg>
)

export default DownArrowSmallIcon
